// extracted by mini-css-extract-plugin
export default {"body":"styles_body__xB4JG","permissions-block":"styles_permissions-block__2VzzW"};